import { PERIOD_KEYS, VAT_MODES, type PeriodKey, type VatMode } from "@apphq/shared/metrics";
import type { Environment } from "@apphq/shared/types";
import { PERIOD_LABELS, VAT_LABELS } from "../lib/format";
import { usePrefs } from "../lib/prefs";

export function Segmented<T extends string>({
  value,
  options,
  onChange,
  label,
}: {
  value: T;
  options: ReadonlyArray<{ value: T; label: string }>;
  onChange: (v: T) => void;
  label: string;
}) {
  return (
    <div className="segmented" role="group" aria-label={label}>
      {options.map((o) => (
        <button key={o.value} type="button" className={o.value === value ? "seg active" : "seg"} aria-pressed={o.value === value} onClick={() => onChange(o.value)}>
          {o.label}
        </button>
      ))}
    </div>
  );
}

const ENV_OPTIONS: ReadonlyArray<{ value: Environment; label: string }> = [
  { value: "production", label: "Productie" },
  { value: "sandbox", label: "Sandbox" },
];

export function EnvControl() {
  const { env, set } = usePrefs();
  return <Segmented label="Omgeving" value={env} options={ENV_OPTIONS} onChange={(v) => set({ env: v })} />;
}

export function PeriodControl() {
  const { period, set } = usePrefs();
  return (
    <Segmented<PeriodKey>
      label="Periode"
      value={period}
      options={PERIOD_KEYS.map((k) => ({ value: k, label: PERIOD_LABELS[k] }))}
      onChange={(v) => set({ period: v })}
    />
  );
}

export function VatControl() {
  const { vat, set } = usePrefs();
  return (
    <Segmented<VatMode> label="Bedrag" value={vat} options={VAT_MODES.map((k) => ({ value: k, label: VAT_LABELS[k] }))} onChange={(v) => set({ vat: v })} />
  );
}

/** Period + VAT (the environment is pinned to production; see EnvControl, intentionally not rendered). */
export function EnvVatPeriodControls({ showPeriod = true, showVat = true }: { showPeriod?: boolean; showVat?: boolean }) {
  return (
    <>
      {showPeriod && <PeriodControl />}
      {showVat && <VatControl />}
    </>
  );
}
